import ENDPOINT from "../endpoints";
import { HTTP } from "../http-common";

export function callSearchMauDuThao(payload) {
  return HTTP({
    url: ENDPOINT.MAU_DU_THAO.SEARCH,
    method: "GET",
    params: payload,
  });
}

export function callChiTietMauDuThao(payload) {
  return HTTP({
    url: `${ENDPOINT.MAU_DU_THAO.CHI_TIET}${payload}`,
    method: "GET",
  });
}

export function callApiSuaMauDuThao(payload) {
  return HTTP({
    url: `${ENDPOINT.MAU_DU_THAO.SUA}${payload.Id}`,
    method: "PUT",
    data: payload,
  });
}

export function callApiTaoMauDuThao(payload) {
  return HTTP({
    url: ENDPOINT.MAU_DU_THAO.TAO,
    method: "POST",
    data: payload,
  });
}

export function callApiXoaMauDuThao(payload) {
  return HTTP({
    url: `${ENDPOINT.MAU_DU_THAO.XOA}${payload}`,
    method: "DELETE",
  });
}
